const DB_NAME = "cic_db";
const DB_VERSION = 1;

enum Stores {
  SolicitudesCambioCicEnConstruccion = "solicitudesCambioCicEnConstruccion",
}

const openDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    if (!("indexedDB" in window)) {
      console.log("Este navegador no soporta IndexedDB.");
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      crearStores(db);
    };

    request.onsuccess = () => {
      const db = request.result;
      resolve(db);
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
};

const crearStores = (db: IDBDatabase) => {
  if (
    !db.objectStoreNames.contains(Stores.SolicitudesCambioCicEnConstruccion)
  ) {
    db.createObjectStore(Stores.SolicitudesCambioCicEnConstruccion, {
      keyPath: "idUsuario",
      autoIncrement: false,
    });
  }
};

const getObjectStore = async (storeName: Stores, mode: IDBTransactionMode) => {
  const db = await openDB();
  const transaction = db.transaction([storeName], mode);
  const store = transaction.objectStore(storeName);
  return store;
};

const addData = async <T,>(storeName: Stores, data: T): Promise<void> => {
  const store = await getObjectStore(storeName, "readwrite");
  store.add(data);
};

const getData = async (storeName: Stores, id: any): Promise<any> => {
  const store = await getObjectStore(storeName, "readonly");

  return new Promise((resolve, reject) => {
    const request = store.get(id);

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
};

const addOrUpdateData = async <T,>(
  storeName: Stores,
  data: T
): Promise<void> => {
  const store = await getObjectStore(storeName, "readwrite");
  store.put(data);
};

const deleteData = async (storeName: Stores, id: any): Promise<void> => {
  const store = await getObjectStore(storeName, "readwrite");
  store.delete(id);
};

const servicioBDLocal = {
  Stores,
  addData,
  getData,
  addOrUpdateData,
  deleteData,
};

export default servicioBDLocal;
